import {
  DashboardUrgentNotice,
  DashboardSubscriptionView,
  DashboardProfileCompletionView,
  AdminAttentionItem,
} from '../types/dashboard';

export type MemberPrimaryKind = 'notice' | 'payment' | 'profile';
export type AdminPrimaryKind = 'notice' | 'attention';

export interface MemberPrimarySource {
  kind: MemberPrimaryKind;
  noticeIndex?: number;
  notice?: DashboardUrgentNotice;
  subscription?: DashboardSubscriptionView;
  profileCompletion?: DashboardProfileCompletionView;
}

export interface AdminPrimarySource {
  kind: AdminPrimaryKind;
  noticeIndex?: number;
  notice?: DashboardUrgentNotice;
  attention?: AdminAttentionItem;
}

export function pickMemberPrimarySource(input: {
  urgentNotices: DashboardUrgentNotice[];
  subscription: DashboardSubscriptionView;
  profileCompletion: DashboardProfileCompletionView;
}): MemberPrimarySource | null {
  const noticeIndex = input.urgentNotices.findIndex(n => n.actionLabel && n.actionLink);
  if (noticeIndex >= 0) {
    return {
      kind: 'notice',
      noticeIndex,
      notice: input.urgentNotices[noticeIndex],
    };
  }
  if (input.subscription.showPayNow) {
    return { kind: 'payment', subscription: input.subscription };
  }
  if (input.profileCompletion.percentage < 100) {
    return { kind: 'profile', profileCompletion: input.profileCompletion };
  }
  return null;
}

export function pickAdminPrimarySource(input: {
  urgentNotices: DashboardUrgentNotice[];
  attentionItems: AdminAttentionItem[];
  totalPendingWork: number;
}): AdminPrimarySource | null {
  const noticeIndex = input.urgentNotices.findIndex(n => n.actionLabel && n.actionLink);
  if (noticeIndex >= 0) {
    return {
      kind: 'notice',
      noticeIndex,
      notice: input.urgentNotices[noticeIndex],
    };
  }
  if (input.totalPendingWork > 0) {
    const attention =
      input.attentionItems.find(i => i.count > 0) || input.attentionItems[0];
    if (attention) {
      return { kind: 'attention', attention };
    }
  }
  return null;
}
